import type { CrawlerState, GenericReducer } from '@/types'
import { CrawlerActions, type CrawlerActionsType } from './actions'

const initialState = {
  started: null,
  finished: null,
}

export const crawler: GenericReducer<CrawlerState, CrawlerActionsType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CrawlerActions.SET_STARTED_JOB:
      return {
        ...state,
        started: action.payload,
      }
    case CrawlerActions.SET_FINISHED_JOB:
      return {
        ...state,
        finished: action.payload,
      }
    default:
      return state
  }
}
